import Vue from 'vue'
import Vuex from 'vuex'
// import getters from './getters'
import modules from './modules/index'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
export default new Vuex.Store({
  //   getters,
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  namespaced: true,
  modules
})
